import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const EcommerceWebsitePage: React.FC = () => {
  return <ServicePageTemplate slug="ecommerce-website" />;
};

export default EcommerceWebsitePage;
